module.exports = __webpack_public_path__ + "media/images/Play-big-434761ea0cd0f6d8ea4ba22c7d282b96.png";